import { Crown } from 'lucide-react';
import './ProBadge.css';

interface ProBadgeProps {
  onClick: () => void;
  isPro?: boolean;
}

export default function ProBadge({ onClick, isPro = false }: ProBadgeProps) {
  return (
    <button
      onClick={onClick}
      className="pro-badge-container relative overflow-hidden"
      title={isPro ? "Manage your PRO subscription" : "Upgrade to PRO"}
    >
      <div className="pro-badge-content">
        <Crown size={14} className="pro-badge-icon" />
        <span className="pro-badge-text">PRO</span>
      </div>
      <div className="pro-badge-shimmer"></div>
    </button>
  );
}
